var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _vm.checkPermi([
                "admin:system:store:count",
                "admin:system:store:list",
              ])
                ? _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.onClickTab },
                      model: {
                        value: _vm.artFrom.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.artFrom, "status", $$v)
                        },
                        expression: "artFrom.status",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: {
                          label: "显示中的提货点(" + _vm.headerCount.show + ")",
                          name: "1",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: {
                          label: "隐藏中的提货点(" + _vm.headerCount.hide + ")",
                          name: "0",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-tab-pane", {
                        attrs: {
                          label:
                            "回收站的提货点(" + _vm.headerCount.recycle + ")",
                          name: "2",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { inline: "", model: _vm.artFrom },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "关键字：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入提货点名称/电话",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.artFrom.keywords,
                            callback: function ($$v) {
                              _vm.$set(_vm.artFrom, "keywords", $$v)
                            },
                            expression: "artFrom.keywords",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            on: { click: _vm.search },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:system:store:save"],
                      expression: "['admin:system:store:save']",
                    },
                  ],
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.add },
                },
                [_vm._v("添加提货点")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                size: "small",
                data: _vm.tableData,
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "image",
                  label: "提货点图片",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var index = ref.index
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview" },
                          [
                            _c("el-image", {
                              staticStyle: { width: "36px", height: "36px" },
                              attrs: {
                                src: row.image,
                                "preview-src-list": [row.image],
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "提货点名称",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "提货点电话",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "detailedAddress",
                  label: "地址",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dayTime",
                  label: "营业时间",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "isShow",
                  label: "是否显示",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var index = ref.index
                      return [
                        _vm.checkPermi(["admin:system:store:update:status"])
                          ? _c("el-switch", {
                              attrs: {
                                "active-value": true,
                                "inactive-value": false,
                                "active-text": "显示",
                                "inactive-text": "隐藏",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onchangeIsShow(row.id, row.isShow)
                                },
                              },
                              model: {
                                value: row.isShow,
                                callback: function ($$v) {
                                  _vm.$set(row, "isShow", $$v)
                                },
                                expression: "row.isShow",
                              },
                            })
                          : _c("span", [
                              _vm._v(_vm._s(row.isShow ? "显示" : "隐藏")),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var index = ref.index
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:system:store:info"],
                                expression: "['admin:system:store:info']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.edit(row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm._v(" "),
                        _vm.artFrom.status === "2"
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["admin:system:store:recovery"],
                                    expression:
                                      "['admin:system:store:recovery']",
                                  },
                                ],
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.storeRecovery(row.id)
                                  },
                                },
                              },
                              [_vm._v("恢复")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.artFrom.status === "2"
                          ? _c("el-divider", {
                              attrs: { direction: "vertical" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "admin:system:store:delete",
                                  "admin:system:store:completely:delete",
                                ],
                                expression:
                                  "['admin:system:store:delete', 'admin:system:store:completely:delete']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                _vm.artFrom.status === "2"
                                  ? _vm.allDelete(row.id)
                                  : _vm.storeDelete(row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticClass: "mt20",
            attrs: {
              "current-page": _vm.artFrom.page,
              "page-sizes": [20, 40, 60, 100],
              "page-size": _vm.artFrom.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.sizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("system-store", { ref: "template" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }